import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "p-6 space-y-4"
};
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-slate-600"
};
const _hoisted_5 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3"
};
const _hoisted_6 = ["disabled"];
import { ref, reactive, watch } from 'vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'CircleTopModal',
  props: {
    show: Boolean,
    postData: Object
  },
  emits: ['update:show', 'confirm'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      isTop: 1,
      topSort: 0,
      topExpireTime: ''
    });
    const submitting = ref(false);
    watch(() => props.show, val => {
      if (val && props.postData) {
        form.isTop = props.postData.isTop === 1 ? 0 : 1;
        form.topSort = props.postData.topSort || 0;
        form.topExpireTime = props.postData.topExpireTime ? props.postData.topExpireTime.replace('T', ' ').substring(0, 16) : '';
      }
    });
    const isSettingTop = () => form.isTop === 1;
    const handleClose = () => {
      emit('update:show', false);
    };
    const handleSubmit = () => {
      submitting.value = true;
      emit('confirm', {
        id: props.postData.id,
        isTop: form.isTop,
        topSort: isSettingTop() ? form.topSort : undefined,
        topExpireTime: isSettingTop() && form.topExpireTime ? form.topExpireTime : undefined
      });
    };
    const done = () => {
      submitting.value = false;
      handleClose();
    };
    __expose({
      done
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "md",
          scrollable: false,
          onClose: handleClose
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.postData?.isTop === 1 ? '取消置顶' : '设置置顶'), 1), _createElementVNode("button", {
            onClick: handleClose,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_3, [!isSettingTop() ? (_openBlock(), _createElementBlock("p", _hoisted_4, "确定要取消该动态的置顶状态吗？")) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", null, [_cache[3] || (_cache[3] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "排序值", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.topSort = $event),
            type: "number",
            min: "0",
            placeholder: "值越小越靠前",
            class: "form-input form-number w-full"
          }, null, 512), [[_vModelText, form.topSort, void 0, {
            number: true
          }]]), _cache[4] || (_cache[4] = _createElementVNode("p", {
            class: "text-xs text-slate-400 mt-1"
          }, "值越小排序越靠前", -1))]), _createElementVNode("div", null, [_cache[5] || (_cache[5] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "过期时间", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.topExpireTime = $event),
            type: "datetime-local",
            class: "w-full form-date"
          }, null, 512), [[_vModelText, form.topExpireTime]]), _cache[6] || (_cache[6] = _createElementVNode("p", {
            class: "text-xs text-slate-400 mt-1"
          }, "不填则永不过期", -1))])], 64))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
            onClick: handleClose,
            class: "btn-secondary"
          }, " 取消 "), _createElementVNode("button", {
            onClick: handleSubmit,
            disabled: submitting.value,
            class: "btn-primary"
          }, _toDisplayString(submitting.value ? '提交中...' : '确定'), 9, _hoisted_6)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};